
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-solutions",
      function () {
        return require("private-next-pages/home-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-solutions"])
      });
    }
  